import { Typography } from "@mui/material";
import styled from "styled-components";
import ReactEcharts from "echarts-for-react";
import {
  BLUE_025BB7,
  GRAY_565656,
  GRAY_E0E0E0,
} from "../../../constants/colors";

export const StyledChartDiv = styled.div`
  padding-bottom: 1rem;
`;

export const StyledEchart = styled(ReactEcharts)`
  height: 17rem !important;
`;

export const StyledLayoutHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem 0 1rem 0;
`;

export const StyledLayoutIconReset = styled.div`
  margin-right: 5px;
  color: ${BLUE_025BB7};
`;

export const StyledLayoutLoading = styled.div`
  height: 272px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  & .MuiCircularProgress-root {
    color: ${GRAY_E0E0E0};
  }
`;

export const StyledNoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3.125rem 0 3.125rem 0;
`;

export const StyledNoDataImage = styled.img`
  padding: 0 3.84375rem 0 3.84375rem;
`;

export const StyledTypography = styled(Typography)`
  padding-top: 1rem;
  text-align: center;
  font-weight: 400;
  color: ${GRAY_565656};
`;
